import { render, staticRenderFns } from "./block-notifications-button.vue?vue&type=template&id=2f5ce3ea&scoped=true&lang=pug&"
import script from "./block-notifications-button.vue?vue&type=script&lang=js&"
export * from "./block-notifications-button.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications-button.vue?vue&type=style&index=0&id=2f5ce3ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ce3ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VList,VMenu})
